import { DOCUMENT_PERMISSION_HISTORY_LIST_ROUTE } from 'config/route-consts';
import React from 'react'
import { Redirect, Route, Switch } from "react-router-dom";
import PermissionHistoryList from './PermissionHistoryList/PermissionHistoryList';

function PermissionHistoryView() {
    return (
        <Switch>
            <Route
                key={DOCUMENT_PERMISSION_HISTORY_LIST_ROUTE}
                path={DOCUMENT_PERMISSION_HISTORY_LIST_ROUTE}
                render={(props: any) => {
                    return <PermissionHistoryList {...props} />;
                }}
            />
            <Redirect to={DOCUMENT_PERMISSION_HISTORY_LIST_ROUTE} />
        </Switch>
    );
}

export default PermissionHistoryView
